import { FC, ReactNode, lazy } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
  useSearchParams,
  // useLocation,
} from "react-router-dom";
import Layout from "@/components/Layout/Layout";
const Home = lazy(() => import("@/pages/Home"));
const GiftCoupon = lazy(() => import("@/pages/GiftCoupon"));
// import Longevity from "@/pages/Longevity";
import ScrollToTop from "@/utils/ScrollToTop";
import BlogList from "@/pages/BlogList";
import Contacts from "@/pages/Contacts";
import BlogDetails from "@/pages/BlogDetails";
import AboutUs from "@/pages/AboutUs";
import TeamList from "@/pages/TeamList";
import TeamDetails from "@/pages/TeamDetails";
import Reviews from "@/pages/Reviews";
import NotFound from "@/pages/NotFound";
import EsInvesticijos from "@/pages/EsInvesticijos";
import PrivacyPolicys from "@/pages/PrivacyPolicy";
import CookiesPolicys from "@/pages/CookiesPolicy";
import ClinicalStudy from "@/pages/ClinicalStudy";
// import FullBloodTest from "@/pages/FullBloodTest";
// import EpigeneticsBiologicalAge from "@/pages/EpigeneticsBiologicalAge";
// import FoodSupplements from "@/pages/FoodSupplements";
import Checkout from "@/pages/Checkout";
// import LongevityProgram from "@/pages/LongevityProgram";
// import { MAXI_PROGRAM, MIDI_PROGRAM, MINI_PROGRAM } from "@/data";
import ROUTES from "@/data/Routes";
// import useMetaPixel from "@/custom_hooks/useMetaPixel";
import Login from "@/pages/Login";
import SignUp from "@/pages/SignUp";
// import RegistrationComplete from "@/pages/RegistrationComplete";
import Account from "./pages/Account";
// import Logout from "./pages/Logout";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
// import AcceptInvitation from "@/pages/AcceptInvitation";
// import GeneticsTesting from "@/pages/GeneticsTesting";
// import GenomeTesting from "@/pages/GenomeTesting";
// import AgeSlowingTest from "./pages/AgeSlowingTest";
// import TypeFormCompleted from "./pages/TypeFormCompleted";
// import KlaviyoForm from "./pages/KlaviyoForm";
// import NewsletterSuccess from "./pages/NewsletterSuccess";
// import VerifyEmail from "@/pages/VerifyEmail";
import GoogleCallback from "./pages/GoogleCallback";
// import UserAdditionalInfo from "./pages/UserAdditionalInfo";
import Memberships from "./pages/Memberships";
import FAQ from "./pages/FAQ";
// import GiftCoupon from "./pages/GiftCoupon";
import Dashboard from "./pages/Dashboard";
import Results from "./pages/Results";
import Connectivity from "./pages/Connectivity";
import DashboardLayout from "./components/Layout/DashboardLayout";

import { usePageTracking } from "@/hooks/usePageTracking"; // Import hook
import ConsultationPage from "./pages/ConsultationPage";
import VerifyEmail from "./pages/VerifyEmail";
import RezusRegistration from "./pages/RezusRegistration";

/** Stripe/backend use `/register?...`; canonical app route is `ROUTES.REGISTER`. */
const RegisterAliasRedirect: FC = () => {
  const [searchParams] = useSearchParams();
  const qs = searchParams.toString();
  return (
    <Navigate
      to={qs ? `${ROUTES.REGISTER}?${qs}` : ROUTES.REGISTER}
      replace
    />
  );
};

const RootLayout: FC<{ children: ReactNode }> = ({ children }) => {
  // const location = useLocation();
  // const metaPixel = useMetaPixel();

  usePageTracking(); // Add page tracking

  // useEffect(() => {
  //   if (location.pathname === ROUTES.CHECKOUT && location.search === "")
  //     metaPixel.trackInitiateCheckout(window.location.href);
  // }, [location]);

  return (
    <>
      <ScrollToTop />
      {children}
    </>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />, // Wraps all pages with Header & Footers
    errorElement: <NotFound />,
    children: [
      {
        path: "/",
        element: (
          <RootLayout>
            <Home />
          </RootLayout>
        ),
      },
      {
        path: ROUTES.LOGIN,
        element: (
          <RootLayout>
            <Login />
          </RootLayout>
        ),
      },
      // {
      //   path: ROUTES.LOGOUT,
      //   element: (
      //     <RootLayout>
      //       <Logout />
      //     </RootLayout>
      //   ),
      // },
      {
        path: ROUTES.REGISTER,
        element: (
          <RootLayout>
            <SignUp />
          </RootLayout>
        ),
      },
      {
        path: ROUTES.REGISTER_ALIAS,
        element: (
          <RootLayout>
            <RegisterAliasRedirect />
          </RootLayout>
        ),
      },
      {
        path: ROUTES.FORGOT_PASSWORD,
        element: (
          <RootLayout>
            <ForgotPassword />
          </RootLayout>
        ),
      },
      {
        path: ROUTES.RESET_PASSWORD,
        element: (
          <RootLayout>
            <ResetPassword />
          </RootLayout>
        ),
      },
      // {
      //   path: ROUTES.ACCEPT_INVITATION,
      //   element: (
      //     <RootLayout>
      //       <AcceptInvitation />
      //     </RootLayout>
      //   ),
      // },
      // {
      //   path: "/ilgaamziskumo-programa",
      //   element: (
      //     <RootLayout>
      //       <Longevity />
      //     </RootLayout>
      //   ),
      // },
      // {
      //   path: ROUTES.GENOME_TESTING,
      //   element: (
      //     <RootLayout>
      //       <GenomeTesting />
      //     </RootLayout>
      //   ),
      // },
      {
        path: "/tinklarastis",
        element: (
          <RootLayout>
            <BlogList />
          </RootLayout>
        ),
      },
      {
        path: "/tinklarastis/:slug",
        element: (
          <RootLayout>
            <BlogDetails />
          </RootLayout>
        ),
      },
      {
        path: ROUTES.ABOUT,
        element: (
          <RootLayout>
            <AboutUs />
          </RootLayout>
        ),
      },
      {
        path: ROUTES.TEAM,
        element: (
          <RootLayout>
            <TeamList />
          </RootLayout>
        ),
      },
      {
        path: "/komanda/:id",
        element: (
          <RootLayout>
            <TeamDetails />
          </RootLayout>
        ),
      },
      {
        path: "/atsiliepimai",
        element: (
          <RootLayout>
            <Reviews />
          </RootLayout>
        ),
      },
      {
        path: ROUTES.CONTACTS,
        element: (
          <RootLayout>
            <Contacts />
          </RootLayout>
        ),
      },
      {
        path: "/es-investicija",
        element: (
          <RootLayout>
            <EsInvesticijos />
          </RootLayout>
        ),
      },
      {
        path: ROUTES.PRIVACY_POLICY,
        element: (
          <RootLayout>
            <PrivacyPolicys />
          </RootLayout>
        ),
      },
      {
        path: ROUTES.COOKIES_POLICY,
        element: (
          <RootLayout>
            <CookiesPolicys />
          </RootLayout>
        ),
      },
      {
        path: "/klinikine-studija",
        element: (
          <RootLayout>
            <ClinicalStudy />
          </RootLayout>
        ),
      },
      // {
      //   path: ROUTES.GENETICS_TEST,
      //   element: (
      //     <RootLayout>
      //       <GeneticsTesting />
      //     </RootLayout>
      //   ),
      // },
      // {
      //   path: ROUTES.BLOOD_TEST,
      //   element: (
      //     <RootLayout>
      //       <FullBloodTest />
      //     </RootLayout>
      //   ),
      // },
      // {
      //   path: ROUTES.EPIGENETICS_TEST,
      //   element: (
      //     <RootLayout>
      //       <EpigeneticsBiologicalAge />
      //     </RootLayout>
      //   ),
      // },
      // {
      //   path: ROUTES.SUPPLEMENTS,
      //   element: (
      //     <RootLayout>
      //       <FoodSupplements />
      //     </RootLayout>
      //   ),
      // },
      // {
      //   path: ROUTES.AGE_SLOWING_TEST,
      //   element: (
      //     <RootLayout>
      //       <AgeSlowingTest />
      //     </RootLayout>
      //   ),
      // },
      {
        path: ROUTES.CHECKOUT,
        element: (
          <RootLayout>
            <Checkout />
          </RootLayout>
        ),
      },
      // {
      //   path: MINI_PROGRAM.route,
      //   element: (
      //     <RootLayout>
      //       <LongevityProgram program={MINI_PROGRAM} />
      //     </RootLayout>
      //   ),
      // },
      // {
      //   path: MIDI_PROGRAM.route,
      //   element: (
      //     <RootLayout>
      //       <LongevityProgram program={MIDI_PROGRAM} />
      //     </RootLayout>
      //   ),
      // },
      // {
      //   path: MAXI_PROGRAM.route,
      //   element: (
      //     <RootLayout>
      //       <LongevityProgram program={MAXI_PROGRAM} />
      //     </RootLayout>
      //   ),
      // },
      {
        path: ROUTES.ACCOUNT,
        element: <DashboardLayout />,
        children: [
          {
            index: true,
            element: <Account />,
          },
        ],
      },
      // {
      //   path: ROUTES.REGISTRATION_COMPLETE,
      //   element: (
      //     <RootLayout>
      //       <RegistrationComplete />
      //     </RootLayout>
      //   ),
      // },
      // {
      //   path: ROUTES.TYPEFORM_COMPLETED,
      //   element: (
      //     <RootLayout>
      //       <TypeFormCompleted />
      //     </RootLayout>
      //   ),
      // },
      // {
      //   path: ROUTES.KLAVIYO_FORM,
      //   element: (
      //     <RootLayout>
      //       <KlaviyoForm />
      //     </RootLayout>
      //   ),
      // },
      // {
      //   path: ROUTES.NEWSLETTER_SUCCESS,
      //   element: (
      //     <RootLayout>
      //       <NewsletterSuccess />
      //     </RootLayout>
      //   ),
      // },
      {
        path: ROUTES.VERIFY_EMAIL,
        element: (
          <RootLayout>
            <VerifyEmail />
          </RootLayout>
        ),
      },
      {
        path: ROUTES.GOOGLE_CALLBACK,
        element: (
          <RootLayout>
            <GoogleCallback />
          </RootLayout>
        ),
      },
      // {
      //   path: ROUTES.USER_ADDITIONAL_INFO,
      //   element: (
      //     <RootLayout>
      //       <UserAdditionalInfo />
      //     </RootLayout>
      //   ),
      // },
      {
        path: ROUTES.GIFT_COUPON,
        element: (
          <RootLayout>
            <GiftCoupon />
          </RootLayout>
        ),
      },
      {
        path: ROUTES.MEMBERSHIPS,
        element: (
          <RootLayout>
            <Memberships />
          </RootLayout>
        ),
      },
      {
        path: ROUTES.DASHBOARD,
        element: <DashboardLayout />,
        children: [
          {
            index: true,
            element: <Dashboard />,
          },
        ],
      },
      {
        path: ROUTES.RESULTS,
        element: <DashboardLayout />,
        children: [
          {
            index: true,
            element: <Results />,
          },
        ],
      },
      {
        path: ROUTES.CONNECTIVITY,
        element: <DashboardLayout />,
        children: [
          {
            index: true,
            element: <Connectivity />,
          },
        ],
      },
      {
        path: ROUTES.FAQ,
        element: (
          <RootLayout>
            <FAQ />
          </RootLayout>
        ),
      },
      {
        path: ROUTES.CONSULTATION,
        element: (
          <RootLayout>
            <ConsultationPage />
          </RootLayout>
        ),
      },
      {
        path: ROUTES.REZUS_REGISTRATION,
        element: (
          <RootLayout>
            <RezusRegistration />
          </RootLayout>
        ),
      },
    ],
  },
  { path: "*", element: <NotFound /> },
]);

export default function AppRouter() {
  return <RouterProvider router={router} />;
}
